<template>
  <div class="one_step">
    <div class="step_shell">
      <div class="field_wrap textfield_wrap">
        <span class="field_label">If you’re completing this application on behalf of your client, please include their details below</span>
      </div>
      <div class="field_wrap textfield_wrap">
        <span class="field_label">First name</span>
        <v-text-field
          data-test-id="step-1-firstname"
          outlined
          v-model="Applicant_First_Name"
          color="#0200b9"
          :rules="name_rules"
          class="text_field"
          maxlength="30"
        />
      </div>

      <div class="field_wrap textfield_wrap">
        <span class="field_label">Last name</span>
        <v-text-field
          data-test-id="step-1-lastname"
          outlined
          v-model="Applicant_Last_Name"
          color="#0200b9"
          :rules="name_rules"
          class="text_field"
          maxlength="30"
        />
      </div>

      <div class="field_wrap textfield_wrap">
        <span class="field_label">Phone</span>
        <v-text-field
          data-test-id="step-1-phone"
          outlined
          v-model="Applicant_Phone"
          color="#0200b9"
          :rules="phone_rules"
          class="text_field"
          maxlength="30"
          minlength="9"
        />
      </div>

      <div class="field_wrap textfield_wrap">
        <span class="field_label">Email</span>
        <v-text-field
          data-test-id="step-1-email"
          outlined
          v-model="Applicant_Email"
          type="email"
          color="#0200b9"
          :rules="email_rules"
          class="text_field"
        />
      </div>
    </div>

    <div class="step_shell for_pb">
      <div class="privacy_box">
        <div class="privacy_box_top">
          <label class="checkbox_label" data-test-id="step-1-privacy-checkbox" >
            <input type="checkbox" v-model="Privacy_Declaration"/>
            <span class="checkbox_visual"></span>
          </label>
          <div
            class="privacy_declaration_intro"
            v-on:click="pd_expanded = !pd_expanded"
            :class="{intro_expanded: pd_expanded}"
            v-html="declaration_intro"
          ></div>
          <button
            data-test-id="step-1-expand-declaration-button"
            class="expand_declaration_button"
            :class="{toggled: pd_expanded}"
            v-on:click="pd_expanded = !pd_expanded"
          ></button>
        </div>

        <div class="privacy_declaration_text" :class="{text_expanded: pd_expanded}">
          <p class="intro">
            In this declaration, "Heartland", "we" or "us" means Heartland Bank Limited,
            and its related entities, successors, assigns, agents and associates, and "you"
            means the person completing this application, each person named in this application,
            each guarantor of any loan made to you and any authorised person or beneficial
            owner of the borrower or any guarantor of any loan made to you (as applicable).
          </p>
          <ul class="privacy-topics">
            <li>Heartland is collecting information about you in accordance with the Privacy Act 2020 
              and our Privacy Statement, and we may not be able to provide you with products or services 
              if you do not provide that information.</li>
            <li>
              That information may be used by us:
              <ul>
                <li>to consider this application for an account or service, including to establish and 
                  verify your identity and to assess your creditworthiness and financial position from time to time</li>
                <li>to consider any future application for products or services which involves you.</li>
              </ul>
            </li>
            <li>
              We can also use it:
              <ul>
                <li>to administer and monitor products or services provided to you</li>
                <li>to comply with legal and regulatory requirements (including identity verification requirements)</li>
                <li>to provide you with information about other products or services, including those of selected third parties</li>
                <li>generally, to develop and run our business; and</li>
                <li>as otherwise described in our Privacy Statement.</li>
              </ul>
            </li>
            <li>
              You agree that - for those purposes – we can provide information about you to, and obtain information
              about you from, other organisations or people we consider appropriate.
              Those organisations might include our service providers, other financial and insurance institutions,
              government departments, our regulators and registered dispute resolution scheme, your employer or accountant,
              third parties for the purposes of fraud prevention, identity verification, and
              any other purposes relevant to those purposes (those third parties may retain information
              and use it for identity verification and fraud detection purposes), and other appropriate persons.
            </li>
            <li>
              We may also exchange information about you (including default information) with credit
              reporting agencies on an ongoing basis. Those agencies may retain that information and provide
              it to other customers who use their credit reporting services.
            </li>
            <li>
              You have rights to access and request correction of your personal information under the Privacy Act 2020. 
              You can do so by contacting us using the details provided on heartland.co.nz/contact-us
            </li>
            <li>
              By proceeding, you confirm that:
              <ul>
                <li>each person named in this application form has read and agrees to the terms above and our Privacy Statement;</li>
                <li>all information provided to us is correct, complete and not misleading; and</li>
                <li>none of those people is an un-discharged bankrupt.</li>
              </ul>
            </li>
          </ul>

          <div class="marketing_optout" v-show="pd_expanded">
            <label class="checkbox_label">
              <input type="checkbox" v-model="marketing_optout" />
              <span class="checkbox_visual"></span>
              <span
                class="label_text"
              >If you do not wish to receive marketing material about Heartland products, please tick this box</span>
            </label>
          </div>
        </div>
        <div
          class="privacy_declaration_error v-messages error--text"
          v-show="privacy_error_shown"
        >Please confirm that you have read and accepted the above declaration</div>
      </div>
    </div>
  </div>
</template>

<script>
import libraryMixin from "./library_mixin";
export default {
  mixins: [libraryMixin],
  props: {
    current: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      Applicant_First_Name: "",
      Applicant_Last_Name: "",
      Applicant_Phone: "",
      Applicant_Email: "",
      marketing_optout: false,
      Accepted_Marketing_Communication: true,
      valid: false,
      Privacy_Declaration: null,
      pd_expanded: false,
      privacy_error_shown: false,
      guid_requested: false
    };
  },
  watch: {
    Privacy_Declaration: {
      handler: function(val) {
        if (!val) {
          this.privacy_error_shown = true;
        } else {
          this.privacy_error_shown = false;
          this.updateData();
        }
      }
    },
    marketing_optout: {
      handler(val) {
        this.Accepted_Marketing_Communication = !val;
        this.updateData();
      }
    }
  },
  computed: {
    clientInfo: function clientInfo() {
      return {
        Applicant_First_Name: this.Applicant_First_Name,
        Applicant_Last_Name: this.Applicant_Last_Name,
        Applicant_Phone: this.Applicant_Phone,
        Applicant_Email: this.Applicant_Email,
        Privacy_Declaration: this.Privacy_Declaration,
        Accepted_Marketing_Communication: !this.marketing_optout
      };
    },
    declaration_intro: function declaration_intro() {
      return (
        'I have read and understood the <span class="look_as_link">Privacy Declaration</span><br/> ' +
        " and I agree to my (or I am authorised to agree on behalf of my client for their) information being collected and dealt with accordingly."
      );
    }
  },
  updated: function() {
    if (this.$parent.$parent.guid) {
      this.debouncedDataUpdate();
    } else if (!this.guid_requested) {
      this.guid_requested = true;
      this.$emit("setGuid");
    }
  },
  methods: {
    updateData: function updateData() {
      this.valid = !!(
        this.Applicant_First_Name &&
        this.Applicant_Last_Name &&
        this.validatePhone(this.Applicant_Phone) &&
        this.validateEmail(this.Applicant_Email) &&
        this.Privacy_Declaration
      );
      this.$emit("updateClientInfo", this.clientInfo);

      this.$emit("stepValid", { step: 1, valid: this.valid });
      if (this.Privacy_Declaration !== null) {
        this.$emit("sendDataToAPI");
      }
    }
  },
  created: function() {
    var app_data = this.$parent.$parent.application.clientInfo;

    this.Applicant_First_Name = app_data.Applicant_First_Name
      ? app_data.Applicant_First_Name
      : "";
    this.Applicant_Last_Name = app_data.Applicant_Last_Name
      ? app_data.Applicant_Last_Name
      : "";
    this.Applicant_Phone = app_data.Applicant_Phone
      ? app_data.Applicant_Phone
      : "";
    this.Applicant_Email = app_data.Applicant_Email
      ? app_data.Applicant_Email
      : "";
    this.marketing_optout =
      typeof app_data.Accepted_Marketing_Communication === "undefined"
        ? false
        : !app_data.Accepted_Marketing_Communication;
    this.Privacy_Declaration =
      typeof app_data.Privacy_Declaration === "undefined"
        ? null
        : app_data.Privacy_Declaration;
  }
};
</script>